
import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition } from '@angular/material/snack-bar';
import { ToastersComponent } from '../../shared/toasters/toasters.component';
import { ToasterTypeEnum } from '../../enums/toasterType.enum';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {


	constructor(
		private _snackBar: MatSnackBar,
		private translateService: TranslateService
	  ) { }

	  show(text: string, action: ToasterTypeEnum, description?: string, buttons: boolean = false, translateInterpolation: { [key: string]: any } = {}) {
		const horizontalPosition: MatSnackBarHorizontalPosition = 'end';
		return this._snackBar.openFromComponent(ToastersComponent, {
		  duration: 3000,
		  data:{
			message: text,
			type: action,
			buttons: buttons,
			description: description,
			interpolationParams: translateInterpolation
		  },
		  horizontalPosition: horizontalPosition,
		  panelClass: ['custom-snackbar']
		});
	  }

	  showError(text: string, translateParams: { [key: string]: any } = {}, position: MatSnackBarHorizontalPosition = 'center') {
		this.translateService.stream(text, translateParams).subscribe(value => text = value);
		return this._snackBar.open(text, 'Error', {
		  duration: 3000, panelClass: 'error-toaster',horizontalPosition: position,
		});
	  }

}
